import { Industry } from 'src/types';

export const PRODUCT_NAME_MAP: Record<Industry, string> = {
  Finance: 'Credit Card',
  Insurance: 'Travel Insurance',
  Gambling: 'Spinzalot Account',
  Mobile: 'Smartphone Upgrade',
  Retail: 'Stridora Membership',
};
